<template>
  <div class="post" id="posts">
    <div class="flex items-center justify-center align-center">
      <div class="w-1/6 h-1 bg-white rounded"></div>
      <h1 class="px-8 py-8 text-4xl font-bold primary">
        Les récentes publications
      </h1>
      <div class="w-1/6 h-1 bg-white rounded"></div>
    </div>
    <!--  -->
    <div
      class="flex flex-wrap items-center justify-center gap-10 my-8 align-center"
    >
      <!-- <div v-for="n in 10" :key="n"> -->
      <CardPost
        v-for="(post, index) in limitedPosts"
        :key="index"
        :post="post"
      ></CardPost>

      <!-- <CardPost></CardPost>
      <CardPost></CardPost>
      <CardPost></CardPost>
      <CardPost></CardPost>
      <CardPost></CardPost> -->
    </div>

    <!--  -->
    <div>
      <p class="text-xl">
        Clique ici pour rejoindre la communauté FreeTalk et faire tes premières
        publications
      </p>
      <button
        @click="$router.push('signup')"
        class="px-16 py-3 my-8 font-medium text-center text-white rounded-lg bg-primary focus:ring-4 focus:outline-none text-md dark:hover:bg-primary"
      >
        S'enregistrer
      </button>
    </div>
  </div>
</template>
<style>
.post {
  background: #153426;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>

<script>
import CardPost from "@/components/website/CardPost.vue";
import { useDashboardStore } from "@/stores/dashboard";
import { onMounted, computed } from "vue";

export default {
  components: {
    CardPost,
  },
  setup() {
    const dashboardStore = useDashboardStore();

    onMounted(() => {
      dashboardStore.getAllCategories();
      dashboardStore.getAllPosts();
      dashboardStore.getAllUsers();
      dashboardStore.getAllComments();
    });

    const limitedPosts = computed(() => dashboardStore.posts.slice(0, 6));

    return { dashboardStore, limitedPosts };
  },
};
</script>
